export default {
  'Translation test': 'Test tłumaczeń',
  'Type name': 'Podaj nazwę',
  Logout: 'Wyloguj',
  'My Courses': 'Moje Kursy',
  'Direct Access': 'Direct Access',
  Mentor: 'Mentor',
  'Prev page': 'Poprzednia',
  'Next page': 'Następna',
  '5 pages forward': 'Do tyłu o 5',
  '5 pages next': 'Do przodu o 5',
  'You must have at least 70% to complete the quest':
    'Aby zaliczyć zadanie, musisz mieć co najmniej 70%',
  'pts.': 'pkt.',
  'Refresh quiz result. Available once every minute.':
    'Odśwież wynik quizu. Dostępne raz na minute',
  'Go to top': 'Idź w góre',
  Previous: 'Poprzedni',
  Next: 'Następny',
  'Your result': 'Twój wynik',
  'How do you rate the': 'Jak oceniasz',
  'Why ?': 'Dlaczego ?',
  Send: 'Wyślij',
  'Find by signature': 'Szukaj po sygnaturze',
  'Currently you are not assigned to any course. Please contact course specialist.':
    'Obecnie nie masz dostępu do żadnego kursu. Aby uzyskać dostęp do kursu skontaktuj się ze swoim opiekunem.',
  'Currently you are not assigned to any course.':
    'Nie jesteś jeszcze zapisany na żaden kurs.',
  'No records found': 'Nie znaleziono rekordów',
  'You are not assigned to any course. Please contact course specialist.':
    'Nie jesteś przypisany/przypisana do żadnego kursu. Skontaktuj się ze swoim opiekunem.',
  'Internet connection lost': 'Brak dostępu do internetu',
  Learning: 'Nauka',
  Exams: 'Egzaminy',
  'Links & information': 'Linki i informacje',
  Module: 'Moduł',
  Mode: 'Tryb',
  Courses: 'Kursy',
  Chapter: 'Rozdział',
  Subject: 'Temat',
  Open: 'Otwórz',
  Download: 'Pobierz',
  article: 'Artykuł',
  presentation_pdf: 'Prezentacja',
  presentation_reveal: 'Prezentacja',
  presentation: 'Prezentacja',
  presentations: 'prezentacje',
  exercise: 'Zadanie',
  attachment: 'Załącznik',
  quiz: 'Quiz',
  snippet: 'Wycinek kodu',
  Quizzes: 'Quizy',
  Exercises: 'Zadania',
  Materials: 'Materiały',
  'Learning results': 'Postęp w nauce',
  'Learning report': 'Raport postępów',
  'Exams results': 'Wyniki egzaminów',
  'Page not found': 'Strona o podanym adresie nie istnieje',
  'Go to courses page': 'Przejdź do strony kursów',
  'is not available yet': 'jeszcze niedostępny',
  Result: 'Wynik',
  'Number of quizzes passed': 'Liczba zaliczonych quizów',
  'Number of exercises passed': 'Liczba zaliczonych zadań',
  'Pass criteria are at least': 'Kryteria zaliczenia to co najmniej',
  'You must have at least to pass': 'Aby zaliczyć musisz mieć co najmniej',
  Edit: 'Edytuj',
  Save: 'Zapisz',
  'See the solution': 'Zobacz rozwiązanie',
  Chat: 'Czat',
  'Virtual Classroom': 'Wirtualna klasa',
  'Download the schedule': 'Pobierz harmonogram',
  Student: 'Kursant',
  'E.': 'Z.',
  'Admin panel': 'Panel administratora',
  'Automatic test result': 'Wynik testu automatycznego',
  'Result edited by lecturer': 'Wynik edytowany przez wykładowce',
  'Take this quiz. You can approach the quiz many times. The highest score is included in the score.':
    'Rozwiąż poniższy quiz. Do quizu możesz podchodzić wiele razy. Do oceny zaliczamy najwyższy wynik.',
  'The quiz result may refresh with a delay of several minutes.':
    'Wynik quizu może pojawić się z kilkunastominutowym opóźnieniem.',
  'Go to repository': 'Przejdź do repozytorium',
  'Something went wrong': 'Coś poszło nie tak',
  'This quiz is not available yet': 'Ten quiz nie jest jeszcze dostępny',
  Sharing: 'Udostępnianie',
  Product: 'Produkt',
  Version: 'Wersja',
  material_type_for_rate_presentation: 'prezentację',
  material_type_for_rate_presentation_pdf: 'prezentację',
  material_type_for_rate_presentation_reveal: 'prezentację',
  material_type_for_rate_exercise: 'zadanie',
  material_type_for_rate_attachment: 'załącznik',
  material_type_for_rate_quiz: 'quiz',
  material_type_for_rate_article: 'artykuł',
  material_type_for_rate_snippet: 'wycinek kodu',
  'Add results': 'Dodaj wyniki',
  Recordings: 'Nagrania',
  'Internal Server Error': 'Wewnętrzny błąd serwera',
  'Bad Request': 'Nnieprawidłowe zapytanie',
  Unauthorized: 'Nieautoryzowany dostęp',
  'Not Found': 'Nie znaleziono zasobu',
  'Bad Gateway': 'Serwer nie jest w stanie zrealizować żądania',
  'Back to top': 'Powrót na górę',
  'select exam': 'wybierz egzamin',
  'Are you sure you want to revoke access to materials?':
    'Czy na pewno chcesz zabrać dostęp do materiałów?',
  'Are you sure you want to revoke access to exam?':
    'Czy na pewno chcesz zabrać dostęp do egzaminu?',
  'Results and the repository with the solutions will be deleted.':
    'Wraz z zabraniem dostępu zostaną usunięte wyniki oraz repozytorium z rozwiązaniami.',
  Yes: 'Tak',
  No: 'Nie',
  'Student / Module': 'Kursant / Moduł',
  'Lecturer / Module': 'Wykładowca / Moduł',
  'All students': 'Wszyscy studenci',
  'There are no shared exams': 'Brak udostępnionych egzaminów',
  Initial: 'Inicjalizacja',
  'Build in progress': 'Budowanie w trakcie',
  'Build failed': 'Błąd budowania',
  'Build succeed': 'Wybudowany',
  'Not shared': 'Nie udostępnione',
  Shared: 'Udostępnione',
  Share: 'Udostępnij',
  'Share exams': 'Udostępnij egzaminy',
  'Revoke share': 'Zabierz dostęp',
  'Building succeed': 'Budowanie powiodło się',
  'Building not succeed': 'Budowanie nie powiodło się',
  Retry: 'Powtórz',
  course: 'kurs',
  signature: 'sygnatura',
  'Chapter content': 'Zawartość rozdziału',
  'Ready for shared': 'Gotowe do udostępnienia',
  'You Are Not Allowed to Access This Page': 'Nie masz dostępu do tej strony',
  'No Github account': 'Brak konta Github',
  'Github nick': 'Nazwa Github',
  'Connect your account with GitHub to have access for course materials and solve exercise. Log in to your GitHub account or create new - click':
    'Połącz konto z GitHub, by mieć dostęp do niezbędnych materiałów kursu i móc rozwiązywać zadania. Zaloguj się na swoje konto GitHub lub załóż nowe - kliknij',
  here: 'tutaj',
  'Students reviews report': 'Raport ocen kursantów',
  from: 'od',
  to: 'do',
  'Download report': 'Pobierz raport',
  'Show menu': 'Pokaż menu',
  less: 'mniej',
  more: 'więcej',
  'Pass criteria': 'Kryteria zaliczenia',
  'Github account': 'Konto Github',
  'Student name': 'Imie i nazwisko',
  Comments: 'Komentarze',
  'No comments yet.': 'Nie dodano jeszcze komentarza.',
  Summary: 'Podsumowanie',
  Rated: 'Oceniony',
  'Publish results': 'Opublikuj wynik',
  'Unpublish results': 'Cofnij publikację',
  'Link to repository': 'Link do repozytorium',
  'Are you sure you want to grant access to materials for all students?':
    'Czy na pewno chcesz udostępnić materiały wszystkim kursantom?',
  Copy: 'Kopiuj',
  'Go to Gradebook': 'Przejdź do gradebook',
  'Download presentation': 'Pobierz prezentacje',
  Fullscreen: 'Pełny ekran',
  'Close fullscreen': 'Zamknij tryb pełnoekranowy',
  'Building and sharing is handled by the queue. Click refresh button if the status has not changed.':
    'Budowanie i udostępnanie procesowane jest przez kolejkę. kliknij przycisk odśwież jeśli status się nie zmienił.',
  Refresh: 'Odśwież',
  'Repository not shared': 'Repozytorium nieudostępnione',
  'Repositories not shared': 'Repozytoria nieudostępnione',
  'Share failed': 'Udostępnianie nie powiodło się',
  'Repository build but not shared':
    'Repozytorum wybudowanie, nie udostępnione',
  'Only repositories will be shared': 'Zostaną udostępnione tylko repozytoria',
  'Send team invitation': 'Wyślij zaproszenie do teamu',
  'Send team invitation for github again':
    'Wyślij ponownie zaproszenie do teamu na github',
  'Your courses': 'Twoje kursy',
  "Don't show this screen after logging in":
    'Nie pokazuj tego ekranu po logowaniu',
  'Course Specialist': 'Opiekun',
  Current: 'Obecnie',
  Signature: 'Sygnatura',
  Schedule: 'Harmonogram',
  'Show chapters': 'Pokaż rozdziały',
  'Hide chapters': 'Ukryj rozdziały',
  'Continue learning': 'Kontynuuj naukę',
  articles: 'artykuły',
  quizzes: 'quizy',
  exercises: 'zadania',
  attachments: 'załączniki',
  snippets: 'snippety',
  'lecturer materials': 'materiały wykładowcy',
  Search: 'Szukaj',
  More: 'Więcej',
  'Course schedule': 'Harmonogram kursu',
  Profile: 'Profil',
  'Name and surname': 'Imię i nazwisko',
  Password: 'Hasło',
  'Not linked': 'Niepołączone',
  'Link your GitHub account to our company profile to be able to solve the exercise and proceed the exam':
    'Połącz konto GitHub z profilem naszej organizacji, żeby móc korzystać z zadań i podejść do egzaminu',
  'Link accounts': 'Połącz konta',
  'Old password': 'Stare hasło',
  'New password': 'Nowe hasło',
  'Retry new password': 'Powtórz nowe hasło',
  'Wrong password': 'Nieprawidłowe hasło',
  Name: 'Imię',
  Surname: 'Nazwisko',
  'User profile': 'Profil użytkownika',
  Rate: 'Oceń',
  'Comment has required!': 'Komentarz jest wymagany!',
  'Request issue': 'Zgłoś uwagę',
  'Add issue': 'Dodaj uwagę',
  'Enter a comment': 'Wpisz komentarz',
  'Non scored': 'Niepunktowany',
  'Not started': 'Nierozpoczęty',
  'In progress': 'W trakcie',
  Pass: 'Zaliczony',
  'Pass 100%': 'Zaliczony na 100%',
  'Select the part of content you want to comment':
    'Wpisz komentarz i zaznacz fragment, do którego chcesz zgłosić uwagę',
  Add: 'Dodaj',
  Cancel: 'Anuluj',
  'Add comment': 'Dodaj komentarz',
  'Your opinion': 'Twoja opinia',
  Read: 'Przeczytane',
  'Wrong name': 'Błędne imię',
  'Wrong surname': 'Błędne nazwisko',
  'Passwords must be the same': 'Hasło musi być takie same',
  Lecturer: 'Wykładowca',
  Records: 'Nagrania',
  Change: 'Zmień',
  'Your account has been linked to Github. Now you will have access to the materials.':
    'Twoje konto zostało połączone z Github. Teraz będziesz mieć dostęp do niezbędnych materiałów.',
  Done: 'Zrobione',
  'Open in fullscreen': 'Otwórz w trybie pełnoekranowym',
  'Search phrase': 'Wyszukiwana fraza',
  'Search filter': 'Szukaj w',
  'all materials': 'wszystkie materiały',
  'Show more': 'Więcej',
  'Available later in the course': 'Dostępne w dalszej części kursu',
  'Remove selection': 'Usuń zaznaczenie',
  'Sorry, the server cannot show this page':
    'Przepraszamy serwer nie może wyświetlić strony',
  'Enter the phrase, minimum 3 characters':
    'Wpisz fraze składającą się z minimum 3 znaków',
  'Enter phrase, min. 3 characters': 'Wpisz min. 3-literową frazę',
  'Close the search and go back to previous page':
    'Zamknij wyszukiwarkę i wróć do poprzedniej strony',
  'Close search results': 'Zamknij widok wyszukiwania',
  'Please add your comment':
    'Wpisz komentarz do zgłaszanej uwagi, który pomoże nam poprawić materiał',
  'Similar search results': 'Podobne wyniki wyszukiwania:',
  'Exact results not found.': 'Dokładne wyniki nie zostały znalezione.',
  Language: 'Język',
  'Checking in progress': 'W trakcie sprawdzania',
  Unchecked: 'Niesprawdzone',
  'Click publish to see a score summary':
    'Kliknij publikuj, aby zobaczyć podsumowanie punktacji',
  Published: 'Opublikowane',
  Publish: 'Opublikuj',
  'It is required to check all tasks - complete the score':
    'Wymagane jest sprawdzenie wszystkich zadań - uzupełnij punktację',
  'Courses catalog': 'Katalog kursów',
  Offer: 'Oferta',
  Welcome: 'Witaj',
  'To access the course': 'Aby uzyskać dostęp do kursu',
  'contact your course specialist': 'skontaktuj się ze swoim opiekunem kursu',
  'or find a course for yourself in the': 'lub znajdź kurs dla siebie w',
  'Course Offer.': 'Ofercie kursów.',
  'Learning progress': 'Postępy w nauce',
  'Report for: ': 'Raport dla: ',
  'With modules': 'Włącznie z modułami',
  'With chapters': 'Włącznie z rozdziałami',
  'With materials': 'Włącznie z materiałami',
  'Progress report': 'Raport postępów',
  'First name': 'Imię',
  'Last name': 'Nazwisko',
  'Phone number': 'Telefon',
  Register: 'Zarejestruj się',
  'Log in': 'Zaloguj się',
  'Do you have an account ?': 'Masz już konto?',
  'Create an account': 'Utwórz konto',
  'Privacy policy':
    'Rejestrując się, akceptujesz <a href="https://coderslab.pl/pl/regulamin" target="_blank">Regulamin</a> i <a href="https://coderslab.pl/pl/polityka-prywatnosci" target="_blank">Politykę prywatności</a>.',
  'Incorrect data': 'Nieprawidłowe dane',
  'Thank you for registration.': 'Dziękujemy za rejestrację.',
  'Check your email and activate your account.':
    'W ciągu kilku minut otrzymasz email. Sprawdź go i aktywuj konto.',
  'Account with this email address already exists.':
    'Konto o podanym adresie e-mail już istnieje.',
  'Free course': 'Kurs darmowy',
  'User already exists':
    'Ups! Twoje konto już istnieje. Zostałeś zapisany na wybrany kurs, aby rozpocząć naukę zaloguj się.',
  'Email not received?': 'Nie otrzymałeś maila?',
  'Send it again.': 'Wyślij ponownie.',
  Start: 'Zacznij',
  'learning with': 'naukę z',
  'Create an account on our educational platform and get access to training materials.':
    'Załóż konto na naszej platformie edukacyjnej i otrzymaj dostęp do materiałów szkoleniowych.',
  'no account': 'brak',
  Modules: 'Moduły',
  'Students on page:': 'Kursanci na stronie:',
  'No students on the course': 'Brak kursantów na kursie',
  'All students completed the': 'Wszyscy kursanci ukończyli',
  'students completed the': 'kursantów ukończyło',
  of: 'z',
  chapter: 'rozdział',
  module: 'moduł',
  'All student': 'Wszyscy kursanci',
  'You are enrolling in a free course': 'Zapisujesz się na darmowy kurs',
  'Instance id is missing': 'Wybierz kurs',
  'Analiza danych - bezpłatny kurs': 'Analityk: lekcja próbna',
  'Analityk danych - darmowa lekcja próbna': 'Analityk: lekcja próbna',
};
